<template>
	<div class='d-flex'>
		<img v-if='displayAsOne'
				 :height='imageDimensions.height'
				 :width='imageDimensions.width'
				 :src='imagesMap[digit]' />
		<img
			v-else
			v-for='(digit, index) in cDigits'
			:key='index'
			:height='imageDimensions.height'
			:width='imageDimensions.width'
			:src='imagesMap[digit]' />
	</div>
</template>

<script>
export default {
	name: 'DigitImageDisplay',
	inject: ['imagesMap'],
	props: {
		digit: {
			type: String,
			required: true
		},
		displayAsOne: {
			type: Boolean,
			required: false,
			default: false
		},
		imageDimensions: {
			type: Object,
			required: false,
			default: () => ({
				height: 32,
				width: 32
			})
		}
	},
	computed: {
		cDigits() {
			return this.digit.split('');
		}
	}
};
</script>
